export const localStorageOrganizationIdKey = 'selectedOrganizationId';
export const localStorageFiscalYearIdKey = 'selectedFiscalYearId';
